import React, { createContext, useContext, useEffect } from 'react'
import { isBrowser } from '../utils/generic'
import { useOpenBetsState } from '../hooks/useOpenBetsState'
import { EnvConfig } from '../config/EnvConfig'
import { useGroowthbookLocaleFeature } from '../hooks/useGrowthbook'

const OpenBetsContext = createContext()

export const OpenBetsProvider = ({ children }) => {
  const isSportsEnabled = useGroowthbookLocaleFeature('fe_igp_sports_enabled')
  const {
    openBetsCount,
    isLoading,
    error,
    isInitialized,
    fetchOpenBetsCount,
    refreshOpenBetsCount,
  } = useOpenBetsState(isSportsEnabled)

  useEffect(() => {
    if (!isBrowser() || !isSportsEnabled) return

    const interval = setInterval(
      () => fetchOpenBetsCount(),
      EnvConfig.OPEN_BETS_POLLING_INTERVAL
    )

    return () => {
      clearInterval(interval)
    }
  }, [isSportsEnabled, fetchOpenBetsCount])

  const value = {
    openBetsCount,
    isLoading,
    error,
    isInitialized,
    refreshOpenBetsCount,
  }

  return (
    <OpenBetsContext.Provider value={value}>
      {children}
    </OpenBetsContext.Provider>
  )
}

export const useOpenBets = () => {
  const context = useContext(OpenBetsContext)
  if (!context) {
    throw new Error('useOpenBets must be used within an OpenBetsProvider')
  }
  return context
}
